var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 12,
    viewBox: "0 0 10 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.00004 9.4163L8.87751 5.53882L8.05589 4.73161L5.57661 7.21089V0.666748H4.42346V7.21089L1.94418 4.73161L1.12256 5.53882L5.00004 9.4163Z",
    fill: "#EAA827"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.61262 10.1802H0.38739V11.3333H9.61262V10.1802Z",
    fill: "#EAA827"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.1625ac1a8d03777cabbf94a6d94caab1.svg";
export { ForwardRef as ReactComponent };